module.exports = __webpack_public_path__ + "static/img/ai-load-more.6a56416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/ai-load-more.png
// module id = uv2Y
// module chunks = 2